import React, { useState, useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Heading from "../../../../../../common/element/Heading/index.js";
import BtnLight from "../../../../../../common/element/Buttons/btnLight.js";
import Dropdown from "../../../../../../common/element/Dropdown/Dropdown.js";
import Label from "../../../../../../common/element/Label/index.js";
import Input from "../../../../../../common/element/Input/Input.js";
import { setBreadcrumbs } from "../../../../../../redux/classes/breadcrumbsSlice.js";
import Select from "../../../../../../common/element/Select/Select.js";
import Button from "../../../../../../common/element/Buttons/index.js";
import ClientOverviewList from "../ClientsOverview/ClientOverviewList.js";
import LineChart from "../ClientsOverview/chart.js";
import { GenerateClientInductionReport } from "../../../../../../actions/Admin-Client/reports/GenerateClientInductionReport.js";
// import PieChart from "../ProviderUnderAClient/PieChartUnderAClient.js";
import PieChart from "./PieChartUnderAClient.js";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ActivityGauge from "./ActivityGauge.js";
import ProgressCircle from "./ProgressCircle.js";
import ClientInductionList from "./ClientInductionList.js";
import { Pagination } from "../../../../../../common/pagination/index.js";
import useUnauthorizedHandler from "../../../../../../common/snippet/useUnauthorizedHandler.js";
import ThreeDotBouncing from "../../../../../../common/element/PageLoader/index.js";
import ReactPaginate from "react-paginate";
import ClientMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/ClientMultiSelectDropdown.js";
import StatusMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/StatusMultiSelectDropdown.js";
import DateMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/DateMultiSelectDropdown.js";
import ProviderMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/ProviderMultiSelectDropdown.js";
import SiteMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/SiteMultiSelectDropdown.js";
import InductionMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/InductionMultiSelectDropdown.js";
import moment from "moment";
import { CSVLink } from "react-csv";
import logoPDF from "./LogoPDF.png";
import Dialog from "../../../../../../common/element/Dialog/Dialog.js";
const ClientsInductions = () => {
  const csvLinkRef = useRef(null);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const dispatch = useDispatch();
  const [reportData, SetReportData] = useState(null);
  const [loadData, setLoadData] = useState(false);
  const [processedCsvData, setProcessedCsvData] = useState([]);
  const [checkPdfLoad, setCheckPdfLoad] = useState(true);
  const [successText, setSuccessText] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [key, setKey] = useState("custom");
  const [pdfDownloadSuccessDialog, setPdfDownloadSuccessDialog] =
    useState(false);

  const [dateMinMax, setDateMinMax] = useState({
    lowestDate: null,
    greatestDate: null,
  });
  const [getAllinvitedData, SetgetAllinvitedData] = useState({
    search: "",
    client_org_ids: [],
    provider_org_ids: [],
    status: "",
    inductionType: "",
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    publish_date_range: "",
    com_ind_ids: [],
    site_ind_ids: [],
  });

  useEffect(() => {
    dispatch(GenerateClientInductionReport(getAllinvitedData)).then(
      (response) => {
        if (response.success) {
          setLoadData(true);
          SetReportData(response?.data);
          const timestamps = response?.data?.inductionReport?.map((product) =>
            new Date(product?.date_joined).getTime()
          );
          const lowestDate = new Date(Math.min(...timestamps));
          const greatestDate = new Date(Math.max(...timestamps));
          setDateMinMax({ lowestDate, greatestDate });
          setTotalPages(
            Math.ceil(response?.data?.total / getAllinvitedData?.limit)
          );
        } else if (response?.status === 401) {
          handleUnauthorizedAccess();
          setLoadData(true);
        } else {
          setLoadData(true);
        }
      }
    );
  }, [getAllinvitedData]);

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Reports",
          url: "/admin/client/reports",
          home: "/admin/client/dashboard",
        },
        {
          label: "Clients Inductions",
          url: "/admin/client/reports/clients-inductions",
        },
      ])
    );
  }, [dispatch]);

  const handleSort = (empty, column) => {
    // if (column === getAllinvitedData.sort) {
    SetgetAllinvitedData((prevalue) => {
      return {
        ...prevalue,
        ["order"]: getAllinvitedData.order === "asc" ? "desc" : "asc",
        ["sort"]: column,
      };
    });
  };

  const handlePageChange = ({ selected }) => {
    SetgetAllinvitedData((prevalue) => {
      return {
        ...prevalue,
        ["page"]: selected + 1,
      };
    });
  };

  const updateFilter = (fieldName, value) => {
    if (fieldName === "status") {
      SetgetAllinvitedData((prevalue) => {
        return {
          ...prevalue,
          [fieldName]: value 
          ? value.charAt(0).toLowerCase() + value.slice(1) 
          : "",        
          ["page"]: 1,
          ["limit"]: 10,
        };
      });
    } else {
    SetgetAllinvitedData((prevalue) => {
      return {
        ...prevalue,
        [fieldName]: value,
        ["page"]: 1,
        ["limit"]: 10,
      };
    });
  }
  };

  const csvHeaders = [
    { label: "Client name", key: "client_name" },
    { label: "Provider", key: "provider_name" },
    { label: "Induction name", key: "company_ind_name" },
    { label: "Workers assigned", key: "worker_assigned" },
    { label: "Site", key: "site_name" },
    { label: "Status", key: "status" },
    { label: "Modules", key: "modules_count" },
    { label: "Valid days", key: "valid_days" },
    { label: "Completion rate	", key: "completion_rate	" },
    { label: "Publish date", key: "publish_date" },
  ];

  // Pre-process CSV data to format date fields using Moment.js.

  function getBase64ImageFromUrl(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      // Enable cross-origin loading if necessary
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = (error) => reject(error);
      img.src = url;
    });
  }

  const GetPDFAllData = async () => {
    setPdfDownloadSuccessDialog(true);
    let Payload = {
      search: getAllinvitedData?.search,
      client_org_ids: getAllinvitedData?.client_org_ids,
      provider_org_ids: getAllinvitedData?.provider_org_ids,
      status: getAllinvitedData?.status,
      inductionType: getAllinvitedData?.inductionType,
      sort: getAllinvitedData?.sort,
      order: getAllinvitedData?.order,
      publish_date_range: getAllinvitedData?.publish_date_range,
      com_ind_ids: getAllinvitedData?.com_ind_ids,
      site_ind_ids: getAllinvitedData?.site_ind_ids,
    };

    try {
      const response = await dispatch(GenerateClientInductionReport(Payload));
      if (response.success) {
        setPdfDownloadSuccessDialog(true);
        return response.data; // Return the response data
      } else if (response?.status === 401) {
        handleUnauthorizedAccess();
      }
    } catch (error) {
      console.error("Error fetching PDF data:", error);
      setPdfDownloadSuccessDialog(true);
    } finally {
      setPdfDownloadSuccessDialog(true);
    }
    return null; // Return null if the request is not successful
  };

  const handleExport = async (format) => {
    setSuccessText(format);
    try {
      // Wait for data from GetPDFAllData
      const allReportData = await GetPDFAllData();

      if (!allReportData) {
        setCheckPdfLoad(false);
        console.error("Failed to fetch report data.");
        return;
      }
      setCheckPdfLoad(false);
      if (format === "csv") {
        setProcessedCsvData(
          allReportData?.inductionReport?.map((item) => {
            return csvHeaders.reduce((newItem, header) => {
              let value = item[header.key];
              if (
                (header.key.toLowerCase().includes("creation_date") && value) ||
                header.key.toLowerCase().includes("approval_date")
              ) {
                value = moment(value).format("DD/MM/YYYY");
              }
              newItem[header.key] = value ?? "-";
              return newItem;
            }, {});
          })
        );
      } else if (format === "excel") {
        // Create a header row using the labels from csvHeaders.
        const headerRow = csvHeaders.map((header) => header.label);

        const dataRows = allReportData?.inductionReport?.map((item) =>
          csvHeaders.map((header) =>
            item[header.key] === undefined || item[header.key] === null
              ? "-"
              : item[header.key]
          )
        );

        // Combine header and data rows.
        const exportData = [headerRow, ...dataRows];

        // Convert the AOA to a worksheet.
        const ws = XLSX.utils.aoa_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Save the Excel file.
        XLSX.writeFile(wb, "tableData.xlsx");
      } else if (format === "pdf") {
        const doc = new jsPDF("l"); // Set to landscape mode
        const today = moment().format("DD/MM/YYYY");

        // Set font and add date (top left)
        doc.setFontSize(12);
        doc.text(today, 14, 15);

        // Add title in center
        const title = "Client Induction List";
        doc.setFontSize(16);
        const pageWidth = doc.internal.pageSize.getWidth();
        const titleWidth = doc.getTextWidth(title);
        const titleX = (pageWidth - titleWidth) / 2;
        doc.text(title, titleX, 15);

        // Convert PNG image to Base64
        const logoUrl = logoPDF;
        let logoData;
        try {
          logoData = await getBase64ImageFromUrl(logoUrl);
        } catch (error) {
          console.error("Error converting image to Base64", error);
        }

        // Add logo image at top right if available
        if (logoData) {
          const imageWidth = 40; // Adjust dimensions as needed
          const imageHeight = 10;
          const marginRight = 15;
          doc.addImage(
            logoData,
            "PNG",
            pageWidth - imageWidth - marginRight,
            10,
            imageWidth,
            imageHeight
          );
        }

        // Prepare table headers and rows
        const tableColumn = [
          "S.no",
          "Client name",
          "Provider",
          "Induction name",
          "Workers assigned",
          "Site",
          "Status",
          "Modules",
          "Valid days",
          "Completion rate",
          "Publish date",
        ];

        const tableRows = allReportData?.inductionReport?.map((row, index) => [
          index + 1,
          row.client_name,
          row.provider_name,
          (row?.company_ind_name != null
            ? row?.company_ind_name
            : row?.site_ind_name) || "-",
          row.worker_assigned,
          row?.site_name != null ? row?.site_name : "Company",
          row.status,
          row.modules_count,
          row.valid_days,
          row.completion_rate,
          row.publish_date
            ? moment(row.publish_date).format("DD/MM/YYYY")
            : "-",
        ]);

        // Add table starting below the header
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: 25,
          styles: { fontSize: 10 }, // Reduce font size for better fit
          headStyles: {
            fillColor: "#E5F3FE",
            textColor: "#464A53",
            overflow: "visible",
          },
          bodyStyles: {
            textColor: "#000000",
            overflow: "linebreak",
          },
          columnStyles: {
            0: { cellWidth: "auto" },
            1: { cellWidth: "auto" },
            2: { cellWidth: "auto" },
            3: { cellWidth: "auto" },
            4: { cellWidth: "auto" },
            5: { cellWidth: "auto" },
            6: { cellWidth: "auto" },
            7: { cellWidth: "auto" },
          },
        });

        // Save the PDF
        doc.save("client_induction.pdf");
      }
    } catch (error) {
      console.error("Error exporting data:", error);
    }
  };

  const closeDownloadSuccessPdf = () => {
    setPdfDownloadSuccessDialog(false);
    setTimeout(() => {
      setCheckPdfLoad(true);
    }, 1000);
  };

  useEffect(() => {
    if (processedCsvData.length > 0) {
      csvLinkRef.current.link.click();
    }
  }, [processedCsvData]); // Runs when processedCsvData updates

  return (
    <React.Fragment>
      <div className="flex justify-between mb-5 border-b border-gray-200 pb-5">
        <Heading>Clients Inductions</Heading>
        <div className="flex gap-3">
          <BtnLight className="h-10 w-10 flex items-center justify-center gap-2 text-12">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.40156 2.8778C9.59363 2.48869 9.68967 2.29413 9.82004 2.23197C9.93347 2.17789 10.0653 2.17789 10.1787 2.23197C10.3091 2.29413 10.4051 2.48869 10.5972 2.8778L12.4194 6.56944C12.4761 6.68432 12.5045 6.74176 12.5459 6.78635C12.5826 6.82584 12.6266 6.85783 12.6754 6.88056C12.7306 6.90623 12.794 6.91549 12.9208 6.93402L16.9968 7.5298C17.4261 7.59253 17.6407 7.6239 17.74 7.72874C17.8264 7.81995 17.8671 7.94529 17.8506 8.06985C17.8317 8.21302 17.6763 8.36436 17.3656 8.66702L14.4172 11.5387C14.3253 11.6282 14.2794 11.673 14.2497 11.7263C14.2235 11.7734 14.2066 11.8252 14.2001 11.8788C14.1928 11.9393 14.2036 12.0025 14.2253 12.129L14.921 16.1851C14.9944 16.6129 15.031 16.8269 14.9621 16.9538C14.9021 17.0642 14.7955 17.1417 14.6719 17.1646C14.5299 17.1909 14.3378 17.0899 13.9536 16.8879L10.3097 14.9716C10.1961 14.9119 10.1394 14.882 10.0796 14.8703C10.0266 14.8599 9.97213 14.8599 9.91918 14.8703C9.85937 14.882 9.8026 14.9119 9.68906 14.9716L6.04512 16.8879C5.66095 17.0899 5.46886 17.1909 5.32683 17.1646C5.20325 17.1417 5.09662 17.0642 5.03663 16.9538C4.96768 16.8269 5.00437 16.6129 5.07774 16.1851L5.77342 12.129C5.79511 12.0025 5.80595 11.9393 5.79862 11.8788C5.79212 11.8252 5.77528 11.7734 5.74902 11.7263C5.71937 11.673 5.67341 11.6282 5.5815 11.5387L2.63315 8.66702C2.3224 8.36436 2.16703 8.21302 2.14812 8.06985C2.13167 7.94529 2.17231 7.81995 2.25872 7.72874C2.35804 7.6239 2.57266 7.59253 3.00189 7.5298L7.07794 6.93402C7.2047 6.91549 7.26808 6.90623 7.32328 6.88056C7.37215 6.85783 7.41615 6.82584 7.45284 6.78635C7.49427 6.74176 7.52262 6.68432 7.57933 6.56944L9.40156 2.8778Z"
                stroke="#344054"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </BtnLight>
          <BtnLight className="h-10 w-40 flex items-center justify-center gap-2 text-12">
            Save as custom report
          </BtnLight>

          <div className="export-dropdow">
            <Dropdown title="Export" className="dropdown-btn">
              <Dropdown.Item
                eventKey="a"
                onClick={() => handleExport("csv")}
                className="text-gray-900 font font-medium"
              >
                CSV
              </Dropdown.Item>
              <Dropdown.Item
                eventKey="b"
                onClick={() => handleExport("excel")}
                className="text-gray-900 font font-medium"
              >
                Excel
              </Dropdown.Item>
              <Dropdown.Item
                eventKey="c"
                onClick={() => handleExport("pdf")}
                className="text-gray-900 font font-medium"
              >
                PDF
              </Dropdown.Item>
            </Dropdown>
            {/* HIDDEN CSVLink - clicked programmatically for CSV export */}
            {processedCsvData?.length>0 && (
              <CSVLink
                data={processedCsvData}
                headers={csvHeaders}
                filename="tableData.csv"
                className="hidden"
                ref={csvLinkRef}
                target="_blank"
              />
            )}
          </div>
        </div>
      </div>
      <div className="flex gap-1 cstm-dropdown">
        <div>
          <ClientMultiSelectDropdown
            title="Client"
            updateFilter={updateFilter}
          />
        </div>
        <div>
          <ProviderMultiSelectDropdown
            title="Provider"
            updateFilter={updateFilter}
            client_org_ids={getAllinvitedData?.client_org_ids}
          />
        </div>
        <div>
          <InductionMultiSelectDropdown
            title="Induction"
            updateFilter={updateFilter}
            provider_org_ids={getAllinvitedData?.provider_org_ids}
            client_org_ids={getAllinvitedData?.client_org_ids}
          />
        </div>
        <div>
          <StatusMultiSelectDropdown
            title={"Status"}
            statusData={["active", "draft", "archived"]}
            updateFilter={updateFilter}
          />
        </div>
        <div>
          <SiteMultiSelectDropdown title={"Site"} updateFilter={updateFilter} />
        </div>
        <div>
          <DateMultiSelectDropdown
            title={"Publish date"}
            type={"publish_date_range"}
            setKey={setKey}
            dateMinMax={dateMinMax}
            updateFilter={updateFilter}
            // setDate_range={setDate_range}
          />
        </div>
      </div>

      <div
        className="flex border border-gray-100 rounded-xl p-6 mt-5 gap-6 items-center justify-between
"
      >
        <PieChart chartData={reportData?.staticsGraph} />
        <ActivityGauge chartData={reportData?.staticsGraph} />
        <ProgressCircle chartData={reportData?.staticsGraph} />
      </div>
      <ClientInductionList
        data={reportData}
        handleSort={handleSort}
        getAllinvitedData={getAllinvitedData}
      />
      {!loadData && (
        <div>
          <ThreeDotBouncing />
        </div>
      )}

      {loadData && (
        <div className="flex justify-between mt-3">
          <Pagination
            totalCount={reportData?.total || 0}
            pageNumber={getAllinvitedData.page}
            displayPage={reportData?.inductionReport?.length || 0}
            UpdatePageLimit={SetgetAllinvitedData}
            allfilters={getAllinvitedData}
          />
          {reportData?.total > 0 && (
            <ReactPaginate
              className="flex justify-content-end p-2 align-items-center pagination-wrap"
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              previousLinkClassName={"prev-link"}
              nextLinkClassName={"page-link"}
              breakLinkClassName={"prev-link"}
              previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
              nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
              pageLinkClassName={"px-4 rounded-md"}
              activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
              disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
              renderOnZeroPageCount={null}
              forcePage={getAllinvitedData?.page - 1}
            />
          )}
        </div>
      )}
      <Dialog
        isOpen={pdfDownloadSuccessDialog}
        onClose={closeDownloadSuccessPdf}
        onRequestClose={closeDownloadSuccessPdf}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          {!checkPdfLoad && (
            <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
              <svg
                width="49"
                height="49"
                viewBox="0 0 49 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.894531"
                  y="0.585938"
                  width="48"
                  height="48"
                  rx="24"
                  fill="#D1FADF"
                />
                <path
                  d="M26.8945 14.8555V18.986C26.8945 19.5461 26.8945 19.8261 27.0035 20.04C27.0994 20.2282 27.2524 20.3811 27.4405 20.477C27.6545 20.586 27.9345 20.586 28.4945 20.586H32.6251M28.8945 25.5859H20.8945M28.8945 29.5859H20.8945M22.8945 21.5859H20.8945M26.8945 14.5859H21.6945C20.0144 14.5859 19.1743 14.5859 18.5326 14.9129C17.9681 15.2005 17.5091 15.6595 17.2215 16.224C16.8945 16.8657 16.8945 17.7058 16.8945 19.3859V29.7859C16.8945 31.4661 16.8945 32.3062 17.2215 32.9479C17.5091 33.5124 17.9681 33.9713 18.5326 34.259C19.1743 34.5859 20.0144 34.5859 21.6945 34.5859H28.0945C29.7747 34.5859 30.6148 34.5859 31.2565 34.259C31.821 33.9713 32.2799 33.5124 32.5676 32.9479C32.8945 32.3062 32.8945 31.4661 32.8945 29.7859V20.5859L26.8945 14.5859Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          )}
          {checkPdfLoad && (
            <div>
              <ThreeDotBouncing />
            </div>
          )}
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
            {checkPdfLoad
              ? `${
                  successText.charAt(0).toUpperCase() + successText.slice(1)
                } downloading..`
              : `${
                  successText.charAt(0).toUpperCase() + successText.slice(1)
                } downloaded successfully!`}
          </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => closeDownloadSuccessPdf()}>Close</BtnLight>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default ClientsInductions;
